import React from 'react';
import { Grid, MenuItem, TextField, Typography } from '@mui/material';

export default function CompanyStep({ answers, errors, onChange }) {
  const set = (field, value) => onChange({ ...answers, company: { ...answers.company, [field]: value } });
  const c = answers.company;

  return (
    <>
      <Typography variant="h5" fontWeight={600} gutterBottom>Tell us about your company</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        This becomes your MOVD partner profile. Approval is required before customers can book you.
      </Typography>
      <Grid container spacing={2.5}>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth required label="Company name" value={c.companyName}
            error={!!errors.companyName} helperText={errors.companyName}
            onChange={e => set('companyName', e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Legal business name" value={c.legalName}
            onChange={e => set('legalName', e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Contact name" value={c.contactName}
            onChange={e => set('contactName', e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth required label="Phone" value={c.phone}
            error={!!errors.phone} helperText={errors.phone}
            onChange={e => set('phone', e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Email" type="email" value={c.email}
            helperText="We already have this from your account" disabled
            onChange={e => set('email', e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Website" value={c.website} placeholder="https://"
            onChange={e => set('website', e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth select label="Years in business" value={c.yearsInBusiness}
            onChange={e => set('yearsInBusiness', e.target.value)}>
            {['Less than 1', '1-2', '3-5', '6-10', '11-20', '20+'].map(range => (
              <MenuItem key={range} value={range === 'Less than 1' ? 0 : parseInt(range, 10)}>{range}</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Business address" value={c.address}
            onChange={e => set('address', e.target.value)} />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth multiline rows={3} label="Business description" value={c.description}
            placeholder="What should customers know about your company?"
            onChange={e => set('description', e.target.value)} />
        </Grid>
      </Grid>
    </>
  );
}
